import $$api from 'models/api';
import chartsModel from 'models/charts';
import { useEffect, useRef } from 'react';
import Spinner from 'react-bootstrap/Spinner';

import './Charts.scss';

import { SOURCE_JSON } from 'components/QuestionnaireForm/Charts/chartsJson';

import env from 'constants/env';

interface ChartsProps {
    json: any;
    fileName?: string;
}

const useRealJson = true;

const Charts = (props: ChartsProps) => {
    const { json, fileName = 'index5.html' } = props;

    const iframe = useRef(null);
    const iFrameData = useRealJson ? json : SOURCE_JSON;

    const messageHandler = (event: any) => {
        if (event.data.key) {
            chartsModel.events.eventCaught(event.data);
            console.log('CHART EVENT', event.data);
        }
        switch (event?.data?.key) {
            case 'resize': {
                if (typeof event.data.data !== 'number') {
                    return;
                }
                const el = iframe.current as any;
                if (el) {
                    el.height = event?.data?.data + 'px';
                }
                break;
            }
            case 'error':
                console.error(`Diagrams internal error:`, event?.data?.data);
                break;
            case 'navigate':
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        window.addEventListener('message', messageHandler, false);
        return () => {
            window.removeEventListener('message', messageHandler, false);
        };
    }, []);

    useEffect(() => {
        (async () => {
            if (iFrameData && iFrameData.is_payed == undefined) {
                const response = await $$api.qInstances.isPaymentOkFx(iFrameData.q_instance_id);
                iFrameData.is_payed = response.result;
            }
            const el = iframe.current as any;
            if (el) {
                el.contentWindow.postMessage(iFrameData, '*');
            }
        })();
    }, [JSON.stringify(iFrameData), iframe.current]);

    return (
        <div className="w-100">
            {!iFrameData ? (
                <Spinner animation="border" variant="primary" />
            ) : (
                <iframe
                    ref={iframe}
                    title="Chart"
                    src={`${env.REACT_APP_CHARTS_URL}/${fileName}`}
                    id="charts_iframe"
                    data-hj-allow-iframe
                    scrolling="no"
                    className="charts-iframe"
                    onLoad={() => {
                        const el = iframe.current as any;
                        if (el) {
                            el.contentWindow.postMessage(iFrameData, '*');
                        }
                    }}
                />
            )}
        </div>
    );
};

export default Charts;
